

import { useEffect } from "react";
import { klarnaMessaging } from "../../../setup/settings/__product";

export default function KlarnaMessage({ price }: { price: any }) {

    useEffect(() => {
        const clientId = klarnaMessaging.key;

        const script = document.createElement('script');
        script.id = 'klarna-osm-script-tag';
        script.async = true;
        script.setAttribute('data-environment', 'production');
        script.src = 'https://js.klarna.com/web-sdk/v1/klarna.js';
        script.setAttribute('data-client-id', clientId);

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return (
        <div className="klarna mb-5">
            <klarna-placement
                data-key="credit-promotion-auto-size"
                data-purchase-amount={price}
                data-preloaded="true"
                data-locale={klarnaMessaging.dataLocale}>
                <span></span>
            </klarna-placement>
        </div>
    )
}

